import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent } from "vue"
import _imports_0 from '@/assets/img/chevronLeft.svg'


const _hoisted_1 = { class: "genericPadding hasHeader bgWhite" }
const _hoisted_2 = { class: "header withShadow d-flex aling-items-center justify-content-between py-4" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = {
  key: 0,
  class: "text-center"
}
const _hoisted_5 = { class: "fs_12 greyBlue d-block ln_12" }
const _hoisted_6 = { class: "fs_10 grey d-block ln_12" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "sideContainer" }, null, -1)
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = { key: 0 }

export function render(_ctx: any,_cache: any) {
  const _component_event_card = _resolveComponent("event-card")!
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "sideContainer",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
      }, [
        _hoisted_3
      ]),
      (_ctx.communityTitle)
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            _createVNode("span", _hoisted_5, _toDisplayString(_ctx.communityTitle), 1),
            _createVNode("span", _hoisted_6, _toDisplayString(_ctx.$filters.date(_ctx.selectedDay)), 1)
          ]))
        : _createCommentVNode("", true),
      _hoisted_7
    ]),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.events, (item, ii) => {
      return (_openBlock(), _createBlock(_component_event_card, {
        key: ii,
        event: item,
        onClick: ($event: any) => (_ctx.openEvent(item))
      }, null, 8, ["event", "onClick"]))
    }), 128)),
    _createVNode("div", _hoisted_8, [
      (_ctx.events.length == 0)
        ? (_openBlock(), _createBlock("span", _hoisted_9, [
            _createVNode(_component_localized_text, {
              localizedKey: 'app_nessuneventotrovato',
              text: 'Nessun evento trovato'
            })
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}